import {Popover} from 'antd'
import {getType} from 'apis/model/base'
import getLinkToDetail from 'helpers/getLinkToDetail'
import React, {useState} from 'react'
import {BaseItem} from './Item/BaseItem'
import './WithDetailPopup.scss'

const PopupContent = ({ item }) => (
  <BaseItem
    {...{
      avatar: item?.thumbnail,
      to: getLinkToDetail(item),
      type: getType(item),
      cover: item?.cover_photo,
      ...(item ?? {}),
    }}
  />
)

export const WithDetailPopup = ({ item, children }) => {
  const [toggle, setToggle] = useState()
  const content = <PopupContent item={item} />

  if (!item) return children
  return (
    <Popover
      style={{ minWidth: 200 }}
      classNames={{ root: "WithDetailPopup" }}
      placement="bottomLeft"
      mouseEnterDelay={0.3}
      destroyOnHidden
      open={toggle}
      content={content}
      onOpenChange={setToggle}
      trigger="hover">
      {children}
    </Popover>
  )
}
